// SZÁMLÁZÁSI ADATOK EGYBEN — a profil másolható szöveges blokkja (cégnév, székhely, adószám, képviselő, számlázási
// e-mail). Tiszta függvény: a lista sor-akciója és az ügyfél-adatlap ugyanezt másolja, egy formátummal.
//
// FORMÁTUM: „Címke: érték" soronként — egy levélbe vagy egy másik rendszer mezőibe illesztve is egyértelmű, melyik
// adat melyik. Az üres mező SORA kimarad (nincs „Adószám: —"). A képviselő a MA érvényes ügyvezető.
import { type TFunction } from 'i18next';

import { currentDirectorName, type DirectorEntry } from './directors';

import { copyWithToast } from '@/lib/clipboard';
import { todayInZone } from '@/lib/format-datetime';

export interface BillingDetailsSource {
  billingName: string | null;
  countryCode: string | null;
  zipCode: string | null;
  city: string | null;
  address: string | null;
  taxNumber: string | null;
  euTaxNumber: string | null;
  managingDirectors: DirectorEntry[];
  billingEmails: string[];
}

/** A hazai cím: az ország kódja csak külföldi címnél kerül elé (a magyar számlán nem szokás kiírni). */
function seat(p: BillingDetailsSource): string {
  const cityLine = [p.zipCode, p.city].filter(Boolean).join(' ');
  const parts = [cityLine, p.address].filter((x): x is string => Boolean(x?.trim()));
  const country =
    p.countryCode && p.countryCode.toUpperCase() !== 'HU' ? p.countryCode.toUpperCase() : null;
  return [country, parts.join(', ')].filter(Boolean).join(' ');
}

export function billingDetailsText(p: BillingDetailsSource, t: TFunction, today: string): string {
  const rows: [string, string | null][] = [
    [t('billingProfiles.copyDetails.name'), p.billingName],
    [t('billingProfiles.copyDetails.seat'), seat(p) || null],
    [t('billingProfiles.copyDetails.taxNumber'), p.taxNumber],
    [t('billingProfiles.copyDetails.euTaxNumber'), p.euTaxNumber],
    [t('billingProfiles.copyDetails.director'), currentDirectorName(p.managingDirectors, today)],
    [
      t('billingProfiles.copyDetails.emails'),
      p.billingEmails.length > 0 ? p.billingEmails.join(', ') : null,
    ],
  ];
  return rows
    .filter((r): r is [string, string] => r[1] !== null && r[1].trim() !== '')
    .map(([label, value]) => `${label}: ${value.trim()}`)
    .join('\n');
}

/** A két felület (lista sor-akció, ügyfél-adatlap) közös művelete: a blokk a vágólapra, toast-visszajelzéssel. */
export function copyBillingDetails(p: BillingDetailsSource, t: TFunction): void {
  void copyWithToast(billingDetailsText(p, t, todayInZone()), {
    success: t('toast:billingProfiles.detailsCopied'),
    error: t('toast:billingProfiles.copyFailed'),
  });
}
